module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/eventschart/eventschart.component.scss
// module id = ./src/app/shared/components/widgets/eventschart/eventschart.component.scss
// module chunks = main